import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BreedingMethodService } from './breeding-method.service';

@Injectable({
    providedIn: 'root'
})
export class BreedingMethodModalService {
    constructor(
    private modalService: NgbModal,
    private breedingMethodService: BreedingMethodService
    ) {}

    openBreedingMethodModal(methodId: number, callback: any): void {
        this.breedingMethodService.queryBreedingMethod(methodId).subscribe(
            (breedingMethod) => {
                // Here you would open your breeding method modal component
                // For now we'll just log the breeding method data
                if (callback) {
                    callback(breedingMethod);
                }
            }
        );
    }
}
